import {
  Box,
  SimpleGrid,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
// Custom components
import Banner from "../../../views/admin/profile/components/Banner";
import Notifications from "../../../views/admin/profile/components/Notifications";
import MealCardSettings from "../../../views/admin/profile/components/MealCardSettings";
import TableTopCreators from "../../../views/admin/profile/components/TableTopCreators";
import Tables from "../../../views/admin/profile/components/Tables";
import { restaurantService } from '../../../services/restaurantService';
import { pricingService } from '../../../services/pricingService';

// Assets
import banner from "../../../assets/img/auth/banner.png";
import avatar from "../../../assets/img/Posts (1).png";
import React from "react"; 

export default function Overview() {
  const [restaurantDetails, setRestaurantDetails] = useState({
    name: '',
    address: {
      district: '',
      city: ''
    },
    followers: [],
    rank: {
      position: 0
    },
    logo: ''
  });
  const [employeeCount, setEmployeeCount] = useState(0);
  const [userPlan, setUserPlan] = useState('STANDARD');

  const fetchRestaurantData = async () => {
    try {
      const [detailsResponse, statsResponse] = await Promise.all([
        restaurantService.getRestaurantDetails(),
        restaurantService.getRestaurantStats()
      ]);

      if (detailsResponse.success && statsResponse.success) {
        setRestaurantDetails({
          name: detailsResponse.data.name,
          address: detailsResponse.data.address || { district: '', city: '' },
          followers: statsResponse.data.followers || [],
          rank: {
            position: statsResponse.data.rank?.position || 0
          },
          logo: detailsResponse.data.logo || ''
        });
      }
    } catch (error) {
      console.error('Restaurant verileri alınırken hata:', error);
    }
  };

  useEffect(() => {
    fetchRestaurantData();
    
    const interval = setInterval(() => {
      fetchRestaurantData();
    }, 30000);
    
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchPlan = async () => {
      try {
        const pricingInfo = await pricingService.getPricingInfo();
        if (pricingInfo?.success && pricingInfo?.data?.business?.plan) {
          setUserPlan(pricingInfo.data.business.plan);
        }
      } catch (error) {
        console.error('Plan bilgisi alınamadı:', error);
        const business = JSON.parse(localStorage.getItem('business') || '{}');
        if (business.plan) {
          setUserPlan(business.plan);
        }
      }
    };
    
    fetchPlan();
  }, []);

  const handleEmployeeCountChange = (count) => {
    setEmployeeCount(count);
  };

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap="20px" >
        <Banner
          banner={banner}
          avatar={restaurantDetails.logo || avatar}
          name={restaurantDetails.name}
          branch={`${restaurantDetails.address.district || ''}, ${restaurantDetails.address.city || ''} Şubesi`}
          employee={employeeCount}
          followers={restaurantDetails.followers.length}
          rank={restaurantDetails.rank.position}
        />
        <MealCardSettings />
        <Notifications />
      </SimpleGrid>
      <SimpleGrid
        mb='20px'
        columns={{ base: 1, lg: 1 }}
        spacing={{ base: "20px", xl: "20px" }}
      >
        <Tables />
        {userPlan === 'PREMIUM' && (
          <TableTopCreators
            onEmployeeCountChange={handleEmployeeCountChange}
          />
        )}
      </SimpleGrid>
    </Box>
  );
}
